import dataApi from '../'

export default {

  /**
  * Get units that the given user is allowed to see
  */
  getOverview (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/unit/overview',
      params: params
    })
  },
  /***
   * Get all units filtered by organization
   * @param organizationUuid
   * @returns {Promise}
   */
  getAllUnits (organizationUUID) {
    return dataApi.request({
      method: 'get',
      url: 'ui/unit/overview/organization/' + organizationUUID
    })
  },
  /**
  * Get units based on a search value
  */
  getSearch (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/unit/search',
      params: params
    })
  },

  /**
  * Delete unit
  */
  deleteDelete (params) {
    return dataApi.request({
      method: 'delete',
      url: 'ui/unit/delete',
      params: params
    })
  },

  /**
  * Get unit types
  */
  getTypes (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/unit/types',
      params: params
    })
  },

  /**
   * Get unit type families
   */
  getTypeFamilies (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/unit/type/families',
      params: params
    })
  },

  /**
  * Get the unit info for edit
  */
  getInforForEdit (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/unit/info-for-edit',
      params: params
    })
  },

  /**
  * Add unit
  */
  postAdd (params) {
    return dataApi.request({
      method: 'post',
      url: 'ui/unit/add',
      body: params
    })
  },

  /**
  * Edit unit
  */
  putEdit (params) {
    return dataApi.request({
      method: 'put',
      url: 'ui/unit/edit',
      body: params
    })
  },

  /**
  * Get unit summary
  */
  getSummary (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/unit/summary',
      params: params
    })
  },

  /**
   * Get unit inventory
   */
  getInventory (unitUuid) {
    return dataApi.request({
      method: 'get',
      url: 'ui/inventory/' + unitUuid
    })
  },

  /**
  * Get the last transactions
  */
  getLastTransactions (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/unit/last-transactions',
      params: params
    })
  },

  /**
  * Get the campaigns units
  */
  getComponent (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/unit/component',
      params: params
    })
  },

  /**
  * Get overview without subs
  */
  getOverviewWithoutSubs (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/unit/overview-without-subs',
      params: params
    })
  },

  /**
  * Get unit and placeholder status
  */
  getUnitAndPlaceholderStatus (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/unit/status',
      params: params
    })
  },

  /**
  * Get unresolved events for the unit
  */
  getNotifications (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/event/notifications',
      params: params
    })
  },

  /**
   * Get placeholders information for the unit
   */
  getPlaceholderInformation (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/unit/placeholder-information',
      params: params
    })
  },

  /**
   * Get the lines for the transaction
   */
  getTransactionLines (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/transaction/lines',
      params: params
    })
  },

  /**
   * Get acceptable materials
   * @param params
   * @returns {Promise | Promise<unknown>}
   */
  getAcceptableMaterials (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/unit/get-currency-acceptable-materials',
      params: params
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/unit.js